import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Time = ({ className, timestamp, format }) => (
  <span className={className} data-test="time">
    {format ? moment(timestamp).format(format) : moment(timestamp).fromNow()}
  </span>
);

Time.propTypes = {
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  format: PropTypes.string,
  className: PropTypes.string,
};

export default Time;
